import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModuleFederationToolsModule } from '@angular-architects/module-federation-tools';
import { Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import module from 'app/modules/well-schematic-diagram/well-schematic-diagram.module';

@Component({
    selector: 'app-daily-activity-tracker',
    templateUrl: './index.page.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [...module, ModuleFederationToolsModule],
    styleUrls: ['./index.page.scss'],
})
export class IndexPage  {
    @ViewChild('pageContainer', { static: true }) parentElement: ElementRef;
    @ViewChild('ngxDatatable', { static: true }) element: DatatableComponent;
    constructor(
        public router: Router
    ) {}
  
    toggle(routes: any){
      this.router.navigate([`/configurations/well-schematic-diagram/${routes}`]);
    }
}
